import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WebhookConfig } from '../models/webhook-configs';
import { URLService } from './dynamic-url.service';

@Injectable({
  providedIn: 'root',
})
export class WebhookService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient, urlService: URLService) {
    this.baseUrl = urlService.getDynamicUrl();
  }

  getWebhookSettings(): Observable<WebhookConfig> {
    return this.http.get<WebhookConfig>(`${this.baseUrl}/webhooks`);
  }

  saveWebhookSettings(config: WebhookConfig): Observable<WebhookConfig> {
    return this.http.post<WebhookConfig>(`${this.baseUrl}/webhooks`, config);
  }

  deleteWebhookSettings(): Observable<any> {
    return this.http.delete(`${this.baseUrl}/webhooks`);
  }
}
